// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"header_headerWrapper__2s7-a","headerTitleWrapper":"header_headerTitleWrapper__29udo","actionWrapper":"header_actionWrapper__2SZU-"};